<template>
    <div class="main">
        <tabulacao-supervisor tipo="BASE"></tabulacao-supervisor>
    </div>
</template>

<script>
import TabulacaoSupervisor from '@/components/tabulacao/shared/tabulacao-supervisor.vue'

export default {
    components: { TabulacaoSupervisor }
}
</script>
